import Draw, { DrawEvent } from 'ol/interaction/Draw'
import { Circle, Fill, Stroke, Style, RegularShape } from 'ol/style'
import MultiPoint from 'ol/geom/MultiPoint'
import LineString from 'ol/geom/LineString'

const targetStyle = [
  new Style({ zIndex: Infinity, image: new Circle({ radius: 12, snapToPixel: true, stroke: new Stroke({ color: 'rgba(255, 255, 255, 0.6)', width: 5 }) }) }),
  new Style({ zIndex: Infinity, image: new RegularShape({ points: 4, radius: 16, radius2: 0, snapToPixel: true, stroke: new Stroke({ color: 'rgba(255, 255, 255, 0.6)', width: 3 }) }) }),
  new Style({ zIndex: Infinity, image: new Circle({ radius: 12, snapToPixel: true, stroke: new Stroke({ color: 'red', width: 2 }) }) }),
  new Style({ zIndex: Infinity, image: new RegularShape({ points: 4, radius: 16, radius2: 0, snapToPixel: true, stroke: new Stroke({ color: 'red', width: 1 }) }) }),
]

class CustomDraw extends Draw {
  constructor (options) {
    options = options || {}

    const white = [255, 255, 255, 1]
    const editColor = [0, 153, 255, 1]
    const sketchColor = [255, 0, 0, 1]
    const width = 3
    // on utilise self car on ne peut pas utiliser this avant la méthode super()
    let self = null
    // TODO étendre target afin d'utiliser le padding et ne plus utiliser "sketchstyle" pour dessiner la target
    const optOptions = {
      ...{
        style: function (feature) {
          // on va avoir 3 types de features utilisé par Draw:

          // point: le point que l'on déplace a l'écran
          // dans ce cas on renvoit le style du cursor:
          if (feature.getGeometry().getType() === 'Point') {
            return targetStyle
          }

          // polygon: uniquement le remplissage
          if (feature.getGeometry().getType() === 'Polygon') {
            return [
              new Style({
                fill: new Fill({
                  color: [255, 255, 255, 0.5],
                }),
                geometry: function (feature) {
                  if (options.type !== 'Polygon' || !self.showConstructionLine_) { return null }
                  return feature.getGeometry()
                },
              }),

            ]
          }

          // ligne: on affiche du blanc en dessous,
          // en bleu ce qu'on a déjà cliqué et sera validé lors du bouton "valid"
          // en rouge-tiret la dernier bout qui n'est pas encore validé
          if (feature.getGeometry().getType() === 'LineString') {
            return [
              new Style({
                stroke: new Stroke({
                  color: white,
                  width: width + 2,

                }),
                geometry: function (feature) {
                  if (options.type === 'Point' || !self.showConstructionLine_) { return null }
                  return feature.getGeometry()
                },
              }),
              new Style({
                stroke: new Stroke({
                  color: sketchColor,
                  width,
                  lineDash: [10, 10],
                }),
                geometry: function (feature) {
                  if (options.type === 'Point' || !self.showConstructionLine_) { return null }
                  const coordinates = feature.getGeometry().getCoordinates()
                  const nbCoordinates = coordinates.length
                  return nbCoordinates <= 2 ? feature.getGeometry() : new LineString(coordinates.slice(nbCoordinates - 2))
                },
              }),
              // lignes (conditionné sur l'edition de ligne et affichage des lignes de construction)
              new Style({
                stroke: new Stroke({
                  color: editColor,
                  width,
                }),
                geometry: function (feature) {
                  if (options.type === 'Point' || !self.showConstructionLine_) { return null }
                  const coordinates = feature.getGeometry().getCoordinates()
                  const nbCoordinates = coordinates.length
                  return nbCoordinates <= 2 ? null : new LineString(coordinates.slice(0, nbCoordinates - 1))
                },
              }),
              // points de construction (conditionné sur l'edition de ligne ou polygone et affichage des points de construction)
              new Style({
                image: new Circle({
                  radius: width * 2,
                  fill: new Fill({
                    color: editColor,
                  }),
                  stroke: new Stroke({
                    color: white,
                    width: width / 2,
                  }),
                }),
                zIndex: Infinity,
                geometry: function (feature) {
                  if (feature.getGeometry() === null || feature.getGeometry().getType() === 'Point' || !self.showConstructionPoint_) { return null }
                  const coordinates = feature.getGeometry().getCoordinates()
                  coordinates.pop()
                  return new MultiPoint(coordinates)
                },
              }),
            ]
          }
        },
      },
      ...options,
    }

    super(optOptions)

    self = this
    if (!options.viewer) {
      console.error('[CustomDrawTouch] options.viewer non présent')
      return
    }

    this.padding_ = null
    this.viewer = options.viewer

    this.setDigitalizeOptions(options)
  }
}

CustomDraw.prototype.setDigitalizeOptions = function (options) {
  // Nombre max de point de la géométrie
  this.maxPoints_ = options.maxPoints ? options.maxPoints : Infinity
  this.showConstructionPoint_ = typeof options.showConstructionPoint === 'boolean' ? options.showConstructionPoint : false
  this.showConstructionLine_ = typeof options.showConstructionLine === 'boolean' ? options.showConstructionLine : true
  this.snapOptions_ = options.snapOptions ? options.snapOptions : null
}

CustomDraw.prototype.setSnapOptions = function (snapOptions) {
  this.snapOptions_ = snapOptions || null
}

CustomDraw.prototype.setPadding = function () {
  // pas utile mais appelé par data-layer
}

CustomDraw.prototype.getGeometryType = function () {
  return this.type_
}

CustomDraw.prototype.getListPoint = function () {
  let listPoints = []
  if (!this.sketchFeature_ || this.sketchFeature_.getGeometry() === null) { return [] }

  switch (this.sketchFeature_.getGeometry().getType()) {
    case 'Point':
      listPoints = [this.sketchFeature_.getGeometry().getCoordinates()]
      break
    case 'LineString':
      listPoints = this.sketchFeature_.getGeometry().getCoordinates()
      break
    case 'Polygon':
      listPoints = this.sketchFeature_.getGeometry().getCoordinates()[0]
      break
    default:
  }
  // le dernier point est le bout de la ligne non terminée
  listPoints = [].concat(listPoints)
  listPoints.pop()
  return listPoints
}

CustomDraw.prototype.startDrawing_ = function (start) {
  Draw.prototype.startDrawing_.call(this, start)
  // renvoit le nombre de point pour le reflecter sur une IHM par exemple
  const listPoints = this.getListPoint()
  this.dispatchEvent({ type: 'listpoint:change', listPoints, geomtype: this.getGeometryType() })
}

CustomDraw.prototype.removeLastPoints_ = function (n) {
  Draw.prototype.removeLastPoints_.call(this, n)
  // renvoit le nombre de point pour le reflecter sur une IHM par exemple
  const listPoints = this.getListPoint()
  this.dispatchEvent({ type: 'listpoint:change', listPoints, geomtype: this.getGeometryType() })
}

CustomDraw.prototype.addToDrawing_ = function (coordinate) {
  Draw.prototype.addToDrawing_.call(this, coordinate)
  // renvoit le nombre de point pour le reflecter sur une IHM par exemple
  const listPoints = this.getListPoint()
  this.dispatchEvent({ type: 'listpoint:change', listPoints, geomtype: this.getGeometryType() })
}

CustomDraw.prototype.abortDrawing = function () {
  // on veut toujours l'event abortDrawing pour ControlCreatetool
  const sketchFeature = this.abortDrawing_()
  this.dispatchEvent(new DrawEvent('drawabort', sketchFeature))
}

CustomDraw.prototype.handleEvent = function (event) {
  // gestion du snapper: si on snap on change les coordonnées et la souris vas "accrocher"
  const result = this.viewer.getFeatureSnapper().snapTo(event.pixel, event.coordinate, this.snapOptions_)
  if (result) {
    event.coordinate = result.vertex.slice(0, 2)
    event.pixel = result.vertexPixel
  }
  return Draw.prototype.handleEvent.call(this, event)
}

export default CustomDraw
